// Modal preview of Home Stock results for one wizard location (final review).

import type { ReactElement } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { AppModal } from '../ui/AppModal';
import {
  HomeStockLocationResultsSection,
  type HomeStockLocationResultItem,
} from './HomeStockLocationResultsSection';
import { HomeStockLevelLegend } from './HomeStockLevelLegend';

type HomeStockLocationPreviewModalProps = {
  open: boolean;
  locationName: string;
  items: HomeStockLocationResultItem[];
  emptyCategories: string[];
  categoryBadgeIndexMap: ReadonlyMap<string, number>;
  resolveCategoryLabel?: (category: string) => string;
  todayYmd: string;
  taskInstanceId?: string;
  onClose: () => void;
};

export const HomeStockLocationPreviewModal = ({
  open,
  locationName,
  items,
  emptyCategories,
  categoryBadgeIndexMap,
  resolveCategoryLabel,
  todayYmd,
  taskInstanceId,
  onClose,
}: HomeStockLocationPreviewModalProps): ReactElement => {
  const { t } = useLanguage();

  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={t('task.review.stocktakeResultsHeading')}
      closeAriaLabel={t('inventory.wizard.previewLocationResultsCloseAria')}
      backdropZClass="z-[120]"
      panelMaxWidthClass="max-w-lg"
    >
      <div className="flex items-center justify-between gap-3">
        <p className="min-w-0 truncate text-sm font-bold text-primary-600 dark:text-emerald-400">{locationName}</p>
        <HomeStockLevelLegend />
      </div>
      <div className="mt-4">
        <HomeStockLocationResultsSection
          items={items}
          emptyCategories={emptyCategories}
          categoryBadgeIndexMap={categoryBadgeIndexMap}
          resolveCategoryLabel={resolveCategoryLabel}
          todayYmd={todayYmd}
          emptyMessage={t('task.review.inventoryItemsFilteredEmpty')}
          showHeading={false}
          taskInstanceId={taskInstanceId}
        />
      </div>
    </AppModal>
  );
};
